import { BTFileSystem } from "legacyComponents/FileUploadContainer.types";

import { type DocumentInstanceType } from "types/enum";

import type { DocumentTemplateInfo } from "handlers/models";

import { type TemplateType } from "entity/document/Document/Document.api.types";

export class DocumentTemplateEntity {
    constructor(data: { templateList: DocumentTemplateInfo[]; canEdit: boolean }) {
        this.templates = data.templateList.map((t) => new DocumentTemplate(t));
        this.canEdit = data.canEdit;
    }

    templates: DocumentTemplate[];
    canEdit: boolean;
}

export enum DocumentFileType {
    None = 0,
    Word = 1,
    Excel = 2,
    PowerPoint = 3,
}

export class DocumentTemplate {
    constructor(data: Omit<DocumentTemplateInfo, "fileType"> & { fileType?: number }) {
        this.fileType = (data.fileType ?? DocumentFileType.None) as DocumentFileType;
        this.title = data.title ?? "";
        this.documentId = data.documentId ?? 0;
        this.documentInstanceId = data.documentInstanceId ?? 0;
    }

    fileType: DocumentFileType;
    title: string;
    documentId: number;
    documentInstanceId: number;
}

export interface ICreateFromTemplateRequest {
    title: string;
    showOwner: boolean;
    showSubs: boolean;
    docTemplateId?: number;
    entityId: number;
    builderId: number;
    jobId: number;
    templateType: TemplateType;
    docType: DocumentInstanceType;
}

export class CreateFromTemplateResponse {
    constructor(data: BTFileSystem) {
        this.fileSystem = new BTFileSystem(data);
    }

    fileSystem: BTFileSystem;
}
